import { ApiResponse } from '@/types/api'
import {
  CareShareYear,
  TCareAndShareConfigs,
  TCareAndShareMinhBachResponse,
} from '@/types/care-and-share'
import { CareShareFormatter } from '../formatter/__f.care-and-share'
import { httpClient } from './http-client'

export class __cCareShareService {
  static async getCareAndShareConfigs() {
    try {
      const { data } = await httpClient.V4_NEW.get<
        ApiResponse<TCareAndShareConfigs>
      >(`/settings/care-and-share/get-config`)
      return data || []
    } catch (error) {
      console.error('Failed to fetch main homepage settings:', error)
      return null
    }
  }

  static async getCareAndShareMinhBach(): Promise<CareShareYear[] | null> {
    try {
      const { data } = await httpClient.V4_NEW.get<
        ApiResponse<TCareAndShareMinhBachResponse>
      >(`/settings/care-and-share/minh-bach`)
      if (!data?.articles) return null
      return CareShareFormatter.formatMinhBachArticlesToYears(data.articles)
    } catch (error) {
      console.error('Failed to fetch care and share minh bach:', error)
      return null
    }
  }
}
